import { Component } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import {UisService} from "../../../service/services/misc/uis/uis.service";

@Component({
    selector: 'app-side-dialog',
    templateUrl: '../dialog/dialog.component.html',
    styleUrls: ['../dialog/dialog.component.scss'],
    standalone: false
})
export class SideDialogComponent extends DialogComponent {
    constructor(public override dialogRef: DialogRef, public override uisService: UisService) {
        super(dialogRef, uisService);
    }
}
